// extracted by mini-css-extract-plugin
export default {"MONTH":"KebIS4","month":"KebIS4","DAY":"ega_V4","day":"ega_V4","YEAR":"x9Of2v","year":"x9Of2v","fields":"I32FHd","mobile":"MDDsrD"};